import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-delete-popup',
  templateUrl: './delete-popup.component.html',
  styleUrls: ['./delete-popup.component.scss']
})
export class DeletePopupComponent implements OnInit {
  name: string;
  item: any;

  constructor(
    public dialogRef: MatDialogRef<DeletePopupComponent>,
    // @Inject(MAT_DIALOG_DATA) public data: { feedId: string },
    @Inject(MAT_DIALOG_DATA) public data: { item: any, name: string }
  ) {
    this.item = data.item;
    this.name = data.name; 
  }

  ngOnInit(): void {
  }
  dialogClose(action: string): void {
    this.dialogRef.close(action);
  }
  deleteItem(): void {
    this.dialogRef.close('yes'); 
  }
}
